import React from 'react';
import './Header.css';

function Header() {
  return (
    <header className="header">
      <h1 className="header-title">NovelAI 태그</h1>
    </header>
  );
}

export default Header;

